import * as types from '../actions/zoom-actions-types';


const GET_ZOOM_JWT_TOKEN_INITIAL_STATE = {
	isLoading: false,
	results: "",
	error: '',
};

export function getZoomJwtTokenReducer(state = GET_ZOOM_JWT_TOKEN_INITIAL_STATE, action) {
	switch (action.type) {
		case types.GET_ZOOM_JWT_TOKEN_RESET:
			return GET_ZOOM_JWT_TOKEN_INITIAL_STATE
		case types.GET_ZOOM_JWT_TOKEN_REQUEST:
			return { ...state, isLoading: true, results: [] };
		case types.GET_ZOOM_JWT_TOKEN_SUCCESS:
			return { ...state, isLoading: false, results: action.payload };
		case types.GET_ZOOM_JWT_TOKEN_FAILURE:
			return { ...state, isLoading: false, error: 'Error while trying to generate Zoom JWT Token' };
		default:
			return state;
	}
}